import { IFormConfig, InputTypes, ValueTypes } from "app/interfaces"


export default {
	fields: [
		{
			name: 'Modalità Tag Manager',
			key: 'vars.gtag_mode',
			valueType: ValueTypes.STRING,
			inputConfig: {
				type: InputTypes.SELECT,
			},
			defaultValue(){return 'disabled'},
			options: [
				{
					label: 'Disattivato',
					value: 'disabled',
				},
				{
					label: 'Integrato nel sito',
					value: 'website'
				},
				/*{
					label: 'Carica se non presente',
					value: 'load_if_not_website'
				},*/
				{
					label: 'Carica script',
					value: 'always_load'
				}
			]
		},
		{
			name: 'Tag Manager Script',
			key: 'vars.gtag_script',
			valueType: ValueTypes.STRING,
			inputHint: 'Inserisci lo script da caricare nella pagina',
			inputConfig: {
				type: InputTypes.TEXTAREA
			}
		}
	]
} as IFormConfig